import {
    DETACHED_FLAG,
    SHOW_OTHER_CUSTOMER_BUTTON,
    IS_LAST_PAGE,
    CUSTOMER_LIST,
    B2B_PLATFORM_SHIPTO_LIST,
} from 'Actions/customer';

const initialState = {};

export function customer(state = initialState, action) {
    let payload = {};

    switch (action.type) {
        case CUSTOMER_LIST:
            if (action.payload.pageNum <= 1 && state.detachedFlag === false) {
                payload.customerList = action.payload.customerList;
            } else {
                payload.customerList = [
                    ...state.customerList,
                    ...action.payload.customerList,
                ];
            }

            return {...state, ...payload};
        case B2B_PLATFORM_SHIPTO_LIST:
            if (action.payload.pageNum === 1)
                payload.b2bPlatformShipToList = action.payload.data;
            if (action.payload.pageNum > 1) {
                payload.b2bPlatformShipToList = state.b2bPlatformShipToList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case DETACHED_FLAG:
        case SHOW_OTHER_CUSTOMER_BUTTON:
        case IS_LAST_PAGE:
            return {...state, ...action.payload};
        default:
            return state;
    }
}
